var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLintramaxLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.669,
    height: 25.891,
    viewBox: "0 0 22.669 25.891",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4985",
    "data-name": "Group 4985",
    transform: "translate(-1681 -544)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5986",
    "data-name": "Path 5986",
    d: "M1691.334,570.891c-6.25,0-11.334-1.306-11.334-7.556a11.334,11.334,0,1,1,22.669,0C1702.669,569.584,1697.584,570.891,1691.334,570.891Zm0-17.946a10.4,10.4,0,0,0-10.39,10.39c0,5.729,4.661,6.612,10.39,6.612s10.39-.883,10.39-6.612A10.4,10.4,0,0,0,1691.334,552.945Z",
    transform: "translate(1 -1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5987",
    "data-name": "Path 5987",
    d: "M1693.5,572h-2a.5.5,0,0,1,0-1h2a.5.5,0,0,1,0,1Z",
    transform: "translate(1121 2242.5) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5988",
    "data-name": "Path 5988",
    d: "M1691.886,565.55a1.888,1.888,0,0,1-1.632-2.834c.4-.7,3.71-4.042,4.37-4.706a.472.472,0,0,1,.79.456c-.245.9-1.488,5.443-1.89,6.138a1.879,1.879,0,0,1-1.146.88A1.9,1.9,0,0,1,1691.886,565.55Zm2.129-5.572a41.709,41.709,0,0,0-2.944,3.21.944.944,0,1,0,1.636.945A42.111,42.111,0,0,0,1694.015,559.978Z",
    transform: "translate(0.445 -1.326)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3848",
    "data-name": "Ellipse 3848",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "translate(1683 560)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3849",
    "data-name": "Ellipse 3849",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "translate(1685 557)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3850",
    "data-name": "Ellipse 3850",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "translate(1688 554)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3851",
    "data-name": "Ellipse 3851",
    cx: 0.472,
    cy: 0.472,
    r: 0.472,
    transform: "translate(1691.862 552.889)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3852",
    "data-name": "Ellipse 3852",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "translate(1696 554)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3853",
    "data-name": "Ellipse 3853",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "translate(1699 557)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3854",
    "data-name": "Ellipse 3854",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "translate(1701 560)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5989",
    "data-name": "Path 5989",
    d: "M260.6,312H242.348A1.432,1.432,0,0,1,241,310.5v-3a.458.458,0,1,1,.912,0v3a.472.472,0,0,0,.437.5H260.6a.486.486,0,0,0,.456-.5v-3a.458.458,0,1,1,.912,0v3A1.44,1.44,0,0,1,260.6,312Z",
    transform: "translate(1441.034 237)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLintramaxLogo);
export default __webpack_public_path__ + "static/media/lintramaxLogo.c8d498a86824f8a1eb573cb8313ab8cc.svg";
export { ForwardRef as ReactComponent };